import { render, staticRenderFns } from "./highlight.vue?vue&type=template&id=4d97daa2&"
import script from "./highlight.vue?vue&type=script&lang=js&"
export * from "./highlight.vue?vue&type=script&lang=js&"
import style0 from "./highlight.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports